export enum PartyDetailViewType {
	STATEMENT = "statement",
	COLUMN = "column",
	LIST = "list",
}
